"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dictionary = exports.DictionarySerializer = exports.DictionaryIdentifier = void 0;
// MIT © 2017 azu
var DictionaryExpected_1 = require("./DictionaryExpected");
var ddd_base_1 = require("ddd-base");
var DictionaryPatterns_1 = require("./DictionaryPatterns");
var DictionaryAllows_1 = require("./DictionaryAllows");
var DictionarySpecs_1 = require("./DictionarySpecs");
var DictionaryDescription_1 = require("./DictionaryDescription");
var DictionaryTags_1 = require("./DictionaryTags");
var DictionaryIdentifier = /** @class */ (function (_super) {
    __extends(DictionaryIdentifier, _super);
    function DictionaryIdentifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DictionaryIdentifier;
}(ddd_base_1.Identifier));
exports.DictionaryIdentifier = DictionaryIdentifier;
exports.DictionarySerializer = {
    fromJSON: function (json) {
        return new Dictionary({
            id: new DictionaryIdentifier(json.id),
            description: new DictionaryDescription_1.DictionaryDescription(json.description || ""),
            expected: new DictionaryExpected_1.DictionaryExpected(json.expected),
            patterns: DictionaryPatterns_1.DictionaryPatternsSerializer.fromJSON(json.patterns),
            allows: DictionaryAllows_1.DictionaryAllowsSerializer.fromJSON(json.allows),
            specs: DictionarySpecs_1.DictionarySpecsSerializer.fromJSON(json.specs),
            tags: DictionaryTags_1.DictionaryTagsSerializer.fromJSON(json.tags)
        });
    },
    toJSON: function (dictionary) {
        return {
            id: dictionary.id.toValue(),
            description: dictionary.description.value,
            expected: dictionary.expected.value,
            patterns: DictionaryPatterns_1.DictionaryPatternsSerializer.toJSON(dictionary.patterns),
            allows: DictionaryAllows_1.DictionaryAllowsSerializer.toJSON(dictionary.allows),
            specs: DictionarySpecs_1.DictionarySpecsSerializer.toJSON(dictionary.specs),
            tags: DictionaryTags_1.DictionaryTagsSerializer.toJSON(dictionary.tags)
        };
    }
};
var Dictionary = /** @class */ (function (_super) {
    __extends(Dictionary, _super);
    function Dictionary(props) {
        var _this = _super.call(this, props) || this;
        _this.id = props.id;
        _this.description = props.description;
        _this.expected = props.expected;
        _this.patterns = props.patterns;
        _this.allows = props.allows;
        _this.specs = props.specs;
        _this.tags = props.tags;
        return _this;
    }
    Dictionary.prototype.inputExpected = function (expected) {
        return new Dictionary(__assign(__assign({}, this), { expected: expected }));
    };
    // patterns
    Dictionary.prototype.addPattern = function (pattern) {
        return new Dictionary(__assign(__assign({}, this), { patterns: this.patterns.add(pattern) }));
    };
    Dictionary.prototype.updatePattern = function (old, newPattern) {
        return new Dictionary(__assign(__assign({}, this), { patterns: this.patterns.update(old, newPattern) }));
    };
    Dictionary.prototype.removePattern = function (pattern) {
        return new Dictionary(__assign(__assign({}, this), { patterns: this.patterns.remove(pattern) }));
    };
    // allows
    Dictionary.prototype.addAllow = function (allow) {
        return new Dictionary(__assign(__assign({}, this), { allows: this.allows.add(allow) }));
    };
    Dictionary.prototype.updateAllow = function (old, newPattern) {
        return new Dictionary(__assign(__assign({}, this), { allows: this.allows.update(old, newPattern) }));
    };
    Dictionary.prototype.removeAllow = function (allow) {
        return new Dictionary(__assign(__assign({}, this), { allows: this.allows.remove(allow) }));
    };
    // specs
    Dictionary.prototype.addSpec = function (spec) {
        return new Dictionary(__assign(__assign({}, this), { specs: this.specs.add(spec) }));
    };
    Dictionary.prototype.updateSpec = function (oldSpec, newSpec) {
        return new Dictionary(__assign(__assign({}, this), { specs: this.specs.update(oldSpec, newSpec) }));
    };
    Dictionary.prototype.removeSpec = function (spec) {
        return new Dictionary(__assign(__assign({}, this), { specs: this.specs.remove(spec) }));
    };
    Dictionary.prototype.updateSpecs = function (newSpecs) {
        if (newSpecs.equals(this.specs)) {
            return this;
        }
        return new Dictionary(__assign(__assign({}, this), { specs: newSpecs }));
    };
    Dictionary.prototype.updateDescription = function (description) {
        return new Dictionary(__assign(__assign({}, this), { description: description }));
    };
    Dictionary.prototype.updateTags = function (tags) {
        return new Dictionary(__assign(__assign({}, this), { tags: tags }));
    };
    return Dictionary;
}(ddd_base_1.Entity));
exports.Dictionary = Dictionary;
//# sourceMappingURL=Dictionary.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/Dictionary.js
// module id = 418
// module chunks = 0